<template>
    <div class="w-full h-[95%]">
        <form v-if="user" @submit.prevent="submitForm" action="" class="flex flex-col h-full w-full justify-between">
            <div class="grid grid-cols-2 gap-2">
                <div class="flex items-center">
                    <label class="whitespace-nowrap tracking-wide font-semibold pr-1 text-gray-800">
                        Individual Limit:
                    </label>
                    <input type="number" min="0" :max="exportLimitData.thirty_day_export_limit" class="p-1 border h-full w-full" v-model="exportLimitData.individual_export_limit">
                </div>
                <div class="flex items-center">
                    <label class="whitespace-nowrap tracking-wide font-semibold pr-1 text-gray-800">
                        Thirty Day Limit:
                    </label>
                    <input type="number" min="0" class="p-1 border h-full w-full" v-model="exportLimitData.thirty_day_export_limit">
                </div>
            </div>
            <div v-if="exportLogs" class="max-h-64 w-full">
            <base-table class="w-full max-h-64 overflow-auto" >
                <template #table-header>
                    <base-table-header class="">Export Date</base-table-header>
                    <base-table-header class="">Export Count</base-table-header>
                    <!-- <base-table-header>Wave Status</base-table-header> -->
                    <base-table-header class="">Exported IDs</base-table-header>
                </template>
                <template #table-body>
                    <base-table-row v-for="exportLog in exportLogs" :key="exportLog.id">
                        <base-table-cell>
                            <div class=" whitespace-nowrap">
                                {{ formatDateTwoDigitYear(exportLog.created_at) }}
                            </div>
                        </base-table-cell>
                        <base-table-cell>
                            {{ exportLog.number_of_companies_exported }}
                        </base-table-cell>
                        <base-table-cell>
                            {{ exportLog.exported_ids }}
                        </base-table-cell>
                    </base-table-row>
                </template>
            </base-table>
    
                </div>
            <div class="w-full flex items-center justify-center">
                <div class="mx-1">
                    <base-button-affirmative>
                        Save
                    </base-button-affirmative>
                </div>
                <div class="mx-1">
                    <base-button-negative @click.prevent="close">
                        Cancel
                    </base-button-negative>
                </div>
            </div>
        </form>
        <div v-else class="text-lg">
            No Aerocle user associated with this person
        </div>
    </div>
</template>

<script setup>
import { defineProps, ref, reactive, defineEmits, computed } from 'vue';
import { useStore } from 'vuex';
import { updateUserCSVExportLimit, createUserCSVExportLimit } from '@/services/User';
import { useToast } from 'vue-toast-notification';
import { formatDateTwoDigitYear } from '@/composables/formatDate';

const props = defineProps(['user'])
const store = useStore()
const $toast = useToast()
const emit = defineEmits(['close', 'refetchUsers'])

function fetchNewUsers(){
    emit('refetchUsers')
}

function close(){
    emit('close')
}

const exportLimitData = reactive({
    individual_export_limit: props.user ? props.user.csv_export_limit ? props.user.csv_export_limit.individual_export_limit : 0 : null,
    thirty_day_export_limit: props.user ? props.user.csv_export_limit ? props.user.csv_export_limit.thirty_day_export_limit : 0 : null,
})

function submitForm(){
    if(props.user.csv_export_limit){
        updateLimit()
    } else {
        createLimit()
    }
}

async function updateLimit(){
    const token = store.state.auth.token
    const result = await updateUserCSVExportLimit(token, props.user.id, exportLimitData)
    if(result.status == 200){
        $toast.open({
            message: `Successfully updated export limits for ${props.user.first_name} ${props.user.last_name}`,
            type: 'success',
            duration: 3000
        })
        emit('refetchUsers')
        emit('close')
    } else {
        $toast.open({
            message: `Error, could not update export limits for ${props.user.first_name} ${props.user.last_name}`,
            type: 'error',
            duration: 3000
        })
    }
}

async function createLimit(){
    const token = store.state.auth.token
    const result = await createUserCSVExportLimit(token, props.user.id, exportLimitData)
    if(result.status == 201){
        $toast.open({
            message: `Successfully created export limits for ${props.user.first_name} ${props.user.last_name}`,
            type: 'success',
            duration: 3000
        })
        emit('refetchUsers')
        emit('close')
    } else {
        $toast.open({
            message: `Error, could not create export limits for ${props.user.first_name} ${props.user.last_name}`,
            type: 'error',
            duration: 3000
        })
    }
}

const exportLogs = computed(() => {
    return props.user.csv_exports.length > 0 ? props.user.csv_exports : null
})

</script>